import {
  useApiQuery,
  BookingOrdersApi,
  createApiQueryByIdFn,
  type BookingOrderPaymentMethodPayload,
  type ReservationPayDetailsPut,
  type BookingOrdersMollieLinkBody,
  createListQueryFn,
  type BookingorderbasePatchRequest,
  type BookingOrderPatch,
} from "@xs2event/js-lib/api";
import { useMutation } from "@tanstack/vue-query";
import { type MaybeRef, unref, computed } from "vue";

const api = new BookingOrdersApi();
export const usePaymentMethods = (id: MaybeRef<string | undefined>, options?: Parameters<typeof useApiQuery>[3]) => {
  const payload = computed(() => ({ bookingorderId: unref(id) }));
  return useApiQuery(api, "bookingorderpaydetailsGet", payload, {
    ...options,
    enabled: computed(() => !!unref(id)),
  });
};

export const useGetBookingOrdersByIds = createApiQueryByIdFn(api, "bookingorderslistGet", "bookingorderId");

export const useChangePaymentMethod = (id: MaybeRef<string>) => {
  return useMutation({
    mutationFn: async (values: ReservationPayDetailsPut) => {
      const paymentDetails = await api.bookingorderproposedpaydetailsPut({
        bookingorderId: unref(id) as string,
        reservationPayDetailsPut: values,
      });
      return { paymentDetails };
    },
  });
};

export const usePatchBookingOrderMutation = (bookingOrderId: MaybeRef<string>) => {
  return useMutation({
    mutationFn: async (patchBody: BookingOrderPatch) => {
      const patchRequest: BookingorderbasePatchRequest = {
        bookingorderId: unref(bookingOrderId),
        bookingOrderPatch: patchBody,
      };
      return await api.bookingorderbasePatch(patchRequest);
    },
  });
};

export const usePatchPaymentMethod = async (id: MaybeRef<string>, values: BookingOrderPaymentMethodPayload) => {
  return await api.bookingorderpaymentmethoddistributorPatch({
    bookingorderId: unref(id) as string,
    bookingOrderPaymentMethodPayload: values,
  });
};

export const useCreatePaymentLinks = async (id: MaybeRef<string>, values: BookingOrdersMollieLinkBody) => {
  return await api.bookingordermollielinksPost({
    bookingorderId: unref(id) as string,
    bookingOrdersMollieLinkBody: values,
  });
};

export const useGetPaymentLinks = async (id: MaybeRef<string>) => {
  const api = new BookingOrdersApi();
  return await api.bookingordermollielinksGet({
    bookingorderId: unref(id) as string,
  });
};
export const useGetBookingOrderRelistings = createListQueryFn(api, "bookingorderrelistedsalesGet");
